import { useEffect, useState } from "react";
import { initialCartCount, onProductAddedToCart } from "../wordpress";

/**
 * Contagem do carrinho, reativa a qualquer "Afegeix a la cistella" bem
 * sucedido em qualquer lugar da página — cada componente que chama isto
 * mantém seu próprio state, sincronizado pelo mesmo evento do WooCommerce,
 * sem precisar de um contexto React só para isso.
 */
export function useCartCount(): number {
	const [count, setCount] = useState(initialCartCount);

	useEffect(() => onProductAddedToCart(() => setCount((current) => current + 1)), []);

	return count;
}
